<template>
  <b-form-group :label="(label) ? label + ':' : 'Valor:'">
    <b-form-input
      type="number"
      v-model="valor"
      ref="valor"
      :placeholder="(label) ? label : 'Valor'"
      pattern="[0-9]+([\,|\.][0-9]+)?"
      step="0.01"
      @blur="formataValor"
      @change="$emit('change')"
      :disabled="disabled"
    ></b-form-input>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "InputValor",
  data() {
    return {

    };
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value", "label", "disabled"],
  methods: {
    formataValor() {
      if(this.valor) {
        this.valor = parseFloat(this.valor).toFixed(2);
      }
      this.$emit("blur", {});
    }
  }
};
</script>
